<template>
  <div>
    <section class="hero-card">
      <div class="hero-copy">
        <p class="hero-label">Single Sign-On</p>

        <h2>Autenticado com sucesso</h2>

        <p>
          Seleciona uma das aplicações disponíveis abaixo para continuares o
          teu trabalho de forma segura e integrada.
        </p>
      </div>

      <div class="hero-badge">
        <span>{{ availableApps.length }}</span>
        <small>apps disponíveis</small>
      </div>
    </section>

    <section class="apps-section">
      <div class="section-header">
        <div>
          <p class="section-label">Acesso rápido</p>
          <h3>Aplicações disponíveis</h3>
        </div>
      </div>

      <div
        v-if="loading"
        class="empty-state"
      >
        <div class="empty-icon">…</div>

        <h4>A carregar aplicações</h4>

        <p>
          Estamos a obter os acessos disponíveis para o teu perfil.
        </p>
      </div>

      <div
        v-else-if="availableApps.length"
        class="apps-grid compact"
      >
        <article
          v-for="app in availableApps"
          :key="app.id"
          class="app-tile"
          @click="goToApp(app.url)"
        >
          <div class="app-icon">
            {{ getInitials(app.role) }}
          </div>

          <h4>{{ app.role }}</h4>
        </article>
      </div>

      <div
        v-else
        class="empty-state"
      >
        <div class="empty-icon">i</div>

        <h4>Não tens aplicações atribuídas</h4>

        <p>
          Contacta a equipa responsável caso precises de acesso adicional.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import Accesses from '../api/Accesses'
import '@/styles/dashboard-page.css'

export default {
  name: 'DashboardView',

  data() {
    return {
      availableApps: [],
      loading: true
    }
  },

  async mounted() {
    await this.loadAccesses()
  },

  methods: {
    async loadAccesses() {
      try {
        const response = await Accesses.list()

        this.availableApps = response.data
      } catch (error) {
        console.error(
          'Erro ao obter accesses:',
          error?.response?.data || error
        )

        this.availableApps = []
      } finally {
        this.loading = false
      }
    },

    goToApp(url) {
      if (!url) {
        console.error('A aplicação não tem URL configurado.')
        return
      }

      window.location.href = url
    },

    getInitials(name) {
      if (!name) {
        return ''
      }

      return name
        .split(' ')
        .filter(Boolean)
        .map(word => word[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    }
  }
}
</script>